import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";

import "bulma/css/bulma.css";
import "../../../../../index.css";

import swal from "sweetalert";

import {
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import {
  faIdCard,
  faLock,
} from "@fortawesome/free-solid-svg-icons";

import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";

import {
  ClipLoader,
  PulseLoader,
} from "react-spinners";

import { FiTrash2 } from "react-icons/fi";


/* =========================================================
   SHIMMER + TABLE + POPUP NILAI
   ========================================================= */

const shimmerStyle = `
  @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }

  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;

    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );

    background-size: 800px 104px;
  }

  .shimmer-select {
    height: 44px;
    border-radius: 10px;
  }


  /* =========================================================
     INPUT NILAI
     ========================================================= */

  .ysb-score-input {
    transition:
      border-color .12s ease,
      box-shadow .12s ease,
      background-color .12s ease;
  }

  .ysb-row-hover:hover .ysb-score-input:not(.ysb-input-disabled) {
    border-color: #7892ff !important;
    box-shadow: 0 0 0 2px rgba(63, 91, 234, 0.08);
  }

  .ysb-row-hover:hover .ysb-score-input.ysb-input-disabled {
    border-color: #e0e5ee !important;
    box-shadow: none !important;
  }


  /* =========================================================
     POPUP PILIH NILAI
     ========================================================= */

  .ysb-score-popover {
    position: fixed;

    z-index: 99999;

    min-width: 190px;

    padding: 8px;

    border: 1px solid #dbe6ff;
    border-radius: 10px;

    background: #ffffff;

    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .ysb-score-popover-grid-inline {
    display: grid;

    grid-template-columns:
      repeat(5, 1fr);

    gap: 6px;
  }

  .ysb-score-btn {
    display: flex;

    height: 34px;

    align-items: center;
    justify-content: center;

    border: 1px solid #cddcff;
    border-radius: 8px;

    background: #f6f9ff;

    color: #3450a7;

    font-size: 13px;
    font-weight: 700;

    cursor: pointer;

    transition:
      background-color .15s ease,
      border-color .15s ease,
      transform .15s ease;
  }

  .ysb-score-btn:hover {
    border-color: #adc0f0;

    background: #e8f0ff;

    transform: translateY(-1px);
  }

  .ysb-score-btn-trash {
    border-color: #ffd5d5;

    background: #fff5f5;

    color: #dc3545;
  }

  .ysb-score-btn-trash:hover {
    border-color: #ffc2c2;

    background: #ffeaea;
  }


  /* =========================================================
     MODE HANYA LIHAT
     ========================================================= */

  .head-assessment-readonly-banner {
    display: flex;

    width: 100%;

    align-items: flex-start;

    gap: 11px;

    margin:
      4px 0 14px;

    padding:
      12px 14px;

    border:
      1px solid #f0d79d;

    border-radius:
      11px;

    background:
      #fffaf0;

    color:
      #7d5a16;

    font-size:
      12.5px;

    line-height:
      1.55;
  }

  .head-assessment-readonly-banner strong {
    display: block;

    margin-bottom:
      2px;

    color:
      #6f4c0d;

    font-size:
      12.5px;

    font-weight:
      700;
  }

  .head-assessment-readonly-icon {
    display:
      inline-flex;

    width:
      21px;

    height:
      21px;

    flex:
      0 0 21px;

    align-items:
      center;

    justify-content:
      center;

    margin-top:
      1px;

    border-radius:
      50%;

    background:
      #f0aa36;

    color:
      #ffffff;

    font-size:
      12px;

    font-weight:
      800;
  }


  /* =========================================================
     TABLE
     ========================================================= */

  .head-assessment-table-card {
    width:
      100%;

    max-width:
      100%;

    overflow:
      hidden;
  }

  .head-assessment-table-scroll {
    position:
      relative;

    width:
      100%;

    max-width:
      100%;

    max-height:
      570px;

    overflow-y:
      auto !important;

    overflow-x:
      hidden !important;

    -webkit-overflow-scrolling:
      touch;
  }

  .head-assessment-table {
    width:
      100% !important;

    min-width:
      100% !important;

    max-width:
      100% !important;

    margin:
      0 !important;

    table-layout:
      fixed !important;

    border-collapse:
      separate !important;

    border-spacing:
      0 !important;
  }


  /* HEADER */

  .head-assessment-table thead th {
    position:
      sticky !important;

    top:
      0 !important;

    z-index:
      15 !important;

    height:
      54px;

    padding:
      12px 14px !important;

    border-right:
      1px solid #e1e6ef !important;

    border-bottom:
      1px solid #dbe2ee !important;

    background:
      #f3f5ff !important;

    background-clip:
      padding-box !important;

    color:
      #25345f !important;

    font-size:
      12.5px !important;

    font-weight:
      700 !important;

    line-height:
      1.45 !important;

    text-align:
      center !important;

    vertical-align:
      middle !important;

    white-space:
      normal !important;

    overflow-wrap:
      break-word;
  }

  .head-assessment-table thead th:last-child {
    border-right:
      0 !important;
  }


  /* BODY */

  .head-assessment-table tbody td {
    padding:
      12px 14px !important;

    border-right:
      1px solid #e6ebf3 !important;

    border-bottom:
      1px solid #edf0f5 !important;

    background:
      #ffffff !important;

    color:
      #2b3654 !important;

    font-size:
      13px !important;

    vertical-align:
      middle !important;
  }

  .head-assessment-table tbody td:last-child {
    border-right:
      0 !important;
  }

  .head-assessment-table tbody tr:last-child td {
    border-bottom:
      0 !important;
  }

  .head-assessment-table tbody tr:hover td {
    background:
      #fafbff !important;
  }


  /* TINGKATAN */

  .head-assessment-grade {
    text-align:
      center !important;

    vertical-align:
      middle !important;

    font-weight:
      600 !important;

    line-height:
      1.6 !important;

    white-space:
      normal !important;

    overflow-wrap:
      break-word;
  }


  /* NAMA KEGIATAN */

  .head-assessment-activity {
    text-align:
      left !important;

    font-weight:
      500 !important;

    line-height:
      1.65 !important;

    white-space:
      normal !important;

    overflow-wrap:
      break-word;
  }


  /* RATA-RATA */

  .head-assessment-average {
    text-align:
      center !important;

    vertical-align:
      middle !important;

    font-weight:
      700 !important;
  }

  .head-assessment-average.is-locked {
    color:
      #dc3545 !important;
  }


  /* NILAI */

  .head-assessment-score {
    text-align:
      center !important;

    vertical-align:
      middle !important;
  }

  .head-assessment-score-wrap {
    position:
      relative;

    width:
      48px;

    height:
      36px;

    margin:
      0 auto;
  }

  .head-assessment-table .ysb-score-input {
    width:
      46px !important;

    height:
      36px !important;

    margin:
      0 auto;

    padding:
      0 !important;

    border:
      1px solid #dce4f2 !important;

    border-radius:
      9px !important;

    outline:
      none !important;

    background:
      #ffffff !important;

    color:
      #27324f !important;

    font-size:
      13px !important;

    font-weight:
      700 !important;

    text-align:
      center !important;

    box-shadow:
      none !important;
  }

  .head-assessment-table .ysb-score-input:not(:disabled) {
    cursor:
      pointer !important;
  }

  .head-assessment-table .ysb-score-input:not(:disabled):hover {
    border-color:
      #7892ff !important;

    background:
      #f8faff !important;
  }


  /* DISABLED */

  .head-assessment-table .ysb-score-input:disabled,
  .head-assessment-table .ysb-score-input.ysb-input-disabled {
    cursor:
      not-allowed !important;

    border-color:
      #e0e5ee !important;

    background:
      #f2f4f7 !important;

    color:
      #9aa4b7 !important;

    box-shadow:
      none !important;

    opacity:
      1 !important;
  }


  /* LOCK */

  .head-assessment-lock-overlay {
    position:
      absolute;

    inset:
      0;

    display:
      flex;

    align-items:
      center;

    justify-content:
      center;

    pointer-events:
      none;
  }

  .head-assessment-lock-overlay svg {
    color:
      #9e9e9e;

    font-size:
      13px;
  }


  /* SCROLLBAR */

  .head-assessment-table-scroll::-webkit-scrollbar {
    width:
      7px;
  }

  .head-assessment-table-scroll::-webkit-scrollbar-track {
    background:
      #f4f6fb;
  }

  .head-assessment-table-scroll::-webkit-scrollbar-thumb {
    background:
      #bfc6d4;

    border-radius:
      10px;
  }


  @media (max-width: 780px) {

    .head-assessment-table-scroll {
      max-height:
        520px;
    }

    .head-assessment-table thead th,
    .head-assessment-table tbody td {
      padding:
        10px 8px !important;

      font-size:
        11.5px !important;
    }

    .head-assessment-score-wrap {
      width:
        44px;
    }

    .head-assessment-table .ysb-score-input {
      width:
        42px !important;
    }
  }


  @media (max-width: 480px) {

    .head-assessment-table thead th,
    .head-assessment-table tbody td {
      padding:
        9px 5px !important;

      font-size:
        10.5px !important;
    }

    .head-assessment-table .ysb-score-input {
      width:
        38px !important;

      height:
        34px !important;
    }

    .head-assessment-score-wrap {
      width:
        40px;

      height:
        34px;
    }
  }
`;


/* =========================================================
   HELPER TINGKATAN
   ========================================================= */

const getGradeNumber = (detail) => {
  const rawName =
    String(
      detail?.name_tingkatan || ""
    );

  const numberFromName =
    rawName.match(/\d+/)?.[0];

  if (numberFromName) {
    return Number(
      numberFromName
    );
  }

  const idNumber =
    Number(
      detail?.ysb_grade_level_id
    );

  return Number.isNaN(
    idNumber
  )
    ? 999999
    : idNumber;
};


const sortDetailsByTingkatan = (
  details = []
) => {
  return [...details].sort(
    (a, b) => {
      const gradeA =
        getGradeNumber(a);

      const gradeB =
        getGradeNumber(b);

      if (
        gradeA !== gradeB
      ) {
        return (
          gradeA -
          gradeB
        );
      }

      return String(
        a?.name_tingkatan || ""
      ).localeCompare(
        String(
          b?.name_tingkatan || ""
        ),
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      );
    }
  );
};


const flattenElementRows = (
  element
) => {
  const details =
    sortDetailsByTingkatan(
      element?.detail || []
    );

  return details.flatMap(
    (detail) => {
      const rows =
        detail?.rekapan || [];

      return rows.map(
        (rekap) => ({
          ...rekap,

          ysb_grade_level_id:
            detail?.ysb_grade_level_id,

          name_tingkatan:
            detail?.name_tingkatan,

          ysb_element_id:
            detail?.ysb_element_id ||
            element?.id,
        })
      );
    }
  );
};


const buildRowsWithGradeSpan = (
  element
) => {
  const rows =
    flattenElementRows(
      element
    );

  const result = [];

  let i = 0;

  while (
    i < rows.length
  ) {
    const current =
      rows[i];

    const gradeKey =
      current?.ysb_grade_level_id ??
      current?.name_tingkatan ??
      "-";

    let j =
      i + 1;

    while (
      j < rows.length
    ) {
      const next =
        rows[j];

      const nextGradeKey =
        next?.ysb_grade_level_id ??
        next?.name_tingkatan ??
        "-";

      if (
        String(
          nextGradeKey
        ) !==
        String(
          gradeKey
        )
      ) {
        break;
      }

      j += 1;
    }

    const span =
      j - i;

    for (
      let k = i;
      k < j;
      k += 1
    ) {
      result.push({
        ...rows[k],

        __showGrade:
          k === i,

        __gradeRowSpan:
          span,
      });
    }

    i = j;
  }

  return result;
};


/* =========================================================
   COMPONENT
   ========================================================= */

export default function PenilaianKepsek() {

  document.title =
    "Penilaian";


  /* =========================================================
     BASIC
     ========================================================= */

  const [page] =
    useState(1);

  const [limit] =
    useState(1000);

  const [ascending] =
    useState(1);

  const [descending] =
    useState(0);

  const [keyword] =
    useState("");


  const token =
    localStorage.getItem(
      "token"
    );


  const storageBranch =
    localStorage.getItem(
      "ysb_branch_id"
    );


  const storageLevel =
    localStorage.getItem(
      "level"
    );


  const storageSchoolId =
    localStorage.getItem(
      "ysb_school_id"
    );


  const ysbRoleName =
    localStorage.getItem(
      "ysb_role_name"
    );


  /* =========================================================
     ROLE
     ========================================================= */

  const normalizedRoleName =
    String(
      ysbRoleName || ""
    )
      .trim()
      .toLowerCase();


  const normalizedLevel =
    String(
      storageLevel || ""
    )
      .trim()
      .toLowerCase();


  const isDeveloper =
    normalizedLevel ===
    "developer";


  const isPengawasAdab =
    normalizedRoleName ===
    "pengawas adab";


  const isNilaiReadOnlyRole =
    isDeveloper ||
    isPengawasAdab;


  const isTabletOrMobile =
    useMediaQuery({
      query:
        "(max-width: 780px)",
    });


  /* =========================================================
     ROUTER
     ========================================================= */

  const navigate =
    useNavigate();

  const location =
    useLocation();


  /* =========================================================
     DATA
     ========================================================= */

  const [
    getDataSemesterMap,
    setGetDataSemesterMap,
  ] = useState([]);


  const [
    getDataDimensi,
    setGetDataDimensi,
  ] = useState([]);

  const [loadingDimensi, setLoadingDimensi] = useState(true);
  const dimensiRequestRef = useRef(0);


  const [
    getData,
    setGetData,
  ] = useState([]);


  /* =========================================================
     UI STATE
     ========================================================= */

  const [
    hasSearched,
    setHasSearched,
  ] = useState(false);


  const [
    isFirstLoad,
    setIsFirstLoad,
  ] = useState(true);


  const [
    isFilterDirty,
    setIsFilterDirty,
  ] = useState(false);


  const [
    selectedTab,
    setSelectedTab,
  ] = useState(null);


  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    isFetching,
    setIsFetching,
  ] = useState(false);


  const [
    savingKey,
    setSavingKey,
  ] = useState(null);


  const [
    namaTA,
    setNamaTA,
  ] = useState("");


  const [
    namaSmstr,
    setNamaSmstr,
  ] = useState("");


  /* =========================================================
     SCORE PICKER
     ========================================================= */

  const [
    scorePicker,
    setScorePicker,
  ] = useState({
    open: false,

    top: 0,

    left: 0,

    elementId: null,

    rekap: null,
  });


  const originalValueRef =
    useRef(null);


  const popoverRef =
    useRef(null);


  /* =========================================================
     USER
     ========================================================= */

  const id_user =
    localStorage.getItem(
      "id_admin"
    ) || "";


  const output_id_user =
    id_user.replace(
      /[|&;$%@"<>()+,]/g,
      ""
    );


  /* =========================================================
     PERMISSION
     ========================================================= */

  const [
    permission,
    setPermission,
  ] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });


  useEffect(() => {

    const level =
      localStorage.getItem(
        "level"
      );


    const storageItems =
      JSON.parse(
        localStorage.getItem(
          "role_permission"
        )
      ) || [];


    if (
      level === "developer" ||
      level === "superadmin"
    ) {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }


    const found =
      storageItems.find(
        (item) =>
          item.menu?.url ===
          location.pathname
      );


    if (!found) {

      navigate(
        "/dashboard"
      );

      return;
    }


    setPermission({
      create:
        found?.create || 0,

      read:
        found?.read || 0,

      update:
        found?.update || 0,

      delete:
        found?.delete || 0,
    });

  }, [
    location.pathname,
    navigate,
  ]);


  /* =========================================================
     FILTER
     ========================================================= */

  const [
    form2,
    setForm2,
  ] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
  });


  const selectedSemester =
    useMemo(
      () =>
        getDataSemesterMap.find(
          (semester) =>
            String(
              semester?.id
            ) ===
            String(
              form2?.ysb_semester_id
            )
        ) || null,
      [
        getDataSemesterMap,
        form2?.ysb_semester_id,
      ]
    );


  const isSelectedSemesterActive =
    Number(
      selectedSemester?.status
    ) === 1;


  const canUpdateNilai =
    useMemo(() => {

      /* Developer & Pengawas Adab view only */

      if (
        isNilaiReadOnlyRole
      ) {
        return false;
      }


      /* Superadmin boleh */

      if (
        normalizedLevel ===
        "superadmin"
      ) {
        return true;
      }


      return (
        permission?.update === 1 ||
        permission?.update === true
      );

    }, [
      isNilaiReadOnlyRole,
      normalizedLevel,
      permission?.update,
    ]);


  const canInputNilai =
    canUpdateNilai &&
    isSelectedSemesterActive;


  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_dimensi_id;


  /* =========================================================
     API HEADER
     ========================================================= */

  const fetchParams =
    useMemo(
      () => ({
        headers: {
          Authorization:
            `${token}`,

          "Content-Type":
            "application/json",
        },
      }),
      [token]
    );


  /* =========================================================
     MOUNT
     ========================================================= */

  const isMounted =
    useRef(true);


  const abortControllers =
    useRef([]);


  useEffect(() => {

    return () => {

      isMounted.current =
        false;


      abortControllers.current.forEach(
        (controller) =>
          controller.abort()
      );

    };

  }, []);


  /* =========================================================
     FETCH INIT
     ========================================================= */

  const fetchInit =
    useCallback(async () => {

      setLoading(true);


      const controller =
        new AbortController();


      abortControllers.current.push(
        controller
      );


      try {

        const semesterRes = await APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        );

        if (
          !isMounted.current
        ) {
          return;
        }


        /* =========================
           SEMESTER
           ========================= */

        if (
          semesterRes?.status ===
          200
        ) {

          const semesters =
            semesterRes?.data?.data ||
            [];


          const active =
            semesters.find(
              (semester) =>
                Number(
                  semester?.status
                ) === 1
            ) ||
            semesters[0];


          setGetDataSemesterMap(
            semesters
          );


          if (active) {

            setNamaTA(
              active?.name_year ||
              ""
            );


            setNamaSmstr(
              active?.semester ||
              ""
            );


            setForm2(
              (prev) => ({
                ...prev,

                ysb_semester_id:
                  active?.id,
              })
            );

          }

        }


      } catch (err) {

        if (
          err?.name ===
            "CanceledError" ||
          err?.name ===
            "AbortError"
        ) {
          return;
        }


        swal({
          title:
            "Failed",

          text:
            err?.response?.data?.message ||
            err?.message ||
            "Error",

          icon:
            "error",
        });

      } finally {

        if (
          isMounted.current
        ) {
          setLoading(false);
        }

      }

    }, [
      ascending,
      descending,
      fetchParams,
      keyword,
      limit,
      page,
    ]);


  useEffect(() => {

    fetchInit();

  }, [
    fetchInit,
  ]);


  /* =========================================================
     DIMENSI: mengikuti semester dan sekolah user
     ========================================================= */
  useEffect(() => {
    const semesterId = form2.ysb_semester_id;
    const requestId = ++dimensiRequestRef.current;
    const controller = new AbortController();

    setLoadingDimensi(true);
    setGetDataDimensi([]);
    setForm2((prev) =>
      prev.ysb_dimensi_id ? { ...prev, ysb_dimensi_id: "" } : prev
    );

    if (!semesterId || !storageBranch || !storageSchoolId) {
      // Semester / identitas sekolah belum siap: masih tahap inisialisasi.
      // Jika semester sudah ada tetapi sekolah user tidak ada, tidak ada dimensi.
      if (semesterId) setLoadingDimensi(false);
      return () => controller.abort();
    }

    const academicYearId =
      selectedSemester?.ysb_academic_year_id ??
      selectedSemester?.academic_year_id ??
      selectedSemester?.ysb_academic_year?.id ??
      "";

    const fetchDimensi = async () => {
      try {
        const response = await APILA.get("/api/access/dimensis", {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page: 1,
            limit: 10,
            ascending: 1,
            search: "",
            branch: "",
            level: storageLevel || "",
            ysb_academic_year_id: academicYearId,
            ysb_semester_id: semesterId,
            ysb_branch_id: storageBranch,
            ysb_school_id: storageSchoolId,
            ysb_grade_level_id: "",
            ysb_teacher_id: "",
          },
        });
        if (controller.signal.aborted || requestId !== dimensiRequestRef.current) return;
        const dims = (Array.isArray(response?.data?.data) ? response.data.data : [])
          .filter((d) => d?.status === undefined || Number(d.status) === 1);
        setGetDataDimensi(dims);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0]?.id ?? "" }));
      } catch (error) {
        if (controller.signal.aborted || requestId !== dimensiRequestRef.current) return;
        console.error("Gagal mengambil data dimensi:", error);
        setGetDataDimensi([]);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
      } finally {
        if (!controller.signal.aborted && requestId === dimensiRequestRef.current) {
          setLoadingDimensi(false);
        }
      }
    };

    fetchDimensi();
    return () => controller.abort();
  }, [
    form2.ysb_semester_id,
    selectedSemester,
    storageBranch,
    storageSchoolId,
    storageLevel,
    fetchParams,
  ]);

  /* =========================================================
     FETCH TABLE
     ========================================================= */

  const GetResponseData =
    useCallback(async () => {

      if (
        !form2.ysb_semester_id ||
        !form2.ysb_dimensi_id
      ) {
        return;
      }


      try {

        const res =
          await APILA.get(
            "/api/recaps-head",
            {
              params: {

                ysb_semester_id:
                  form2.ysb_semester_id,

                level:
                  storageLevel,

                branch:
                  storageBranch,

                ysb_dimensi_id:
                  form2.ysb_dimensi_id,

                ysb_school_id:
                  storageSchoolId,
              },

              ...fetchParams,
            }
          );


        if (
          res?.status ===
          200
        ) {

          const result =
            Array.isArray(
              res?.data?.data
            )
              ? res.data.data
              : [];


          setGetData(
            result
          );


          setHasSearched(
            true
          );


          setIsFilterDirty(
            false
          );


          const firstElement =
            result?.[0]
              ?.data_element?.[0];


          if (
            firstElement?.name_element
          ) {

            setSelectedTab(
              firstElement
                .name_element
            );

          }

        }

      } catch (err) {

        setGetData([]);


        swal({
          title:
            "Failed",

          text:
            err?.response?.data?.message ||
            "Terjadi kesalahan",

          icon:
            "error",
        });

      }

    }, [
      fetchParams,
      form2.ysb_dimensi_id,
      form2.ysb_semester_id,
      storageBranch,
      storageLevel,
      storageSchoolId,
    ]);


  /* =========================================================
     AUTO TAB
     ========================================================= */

  useEffect(() => {

    if (
      getData.length > 0 &&
      getData?.[0]
        ?.data_element
        ?.length > 0 &&
      !selectedTab
    ) {

      setSelectedTab(
        getData[0]
          .data_element[0]
          .name_element
      );

    }

  }, [
    getData,
    selectedTab,
  ]);


  /* =========================================================
     FIRST LOAD
     ========================================================= */

  useEffect(() => {

    if (
      !isFirstLoad ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) {
      return;
    }


    const runFirstLoad =
      async () => {

        setIsFetching(
          true
        );


        try {

          await GetResponseData();


          setHasSearched(
            true
          );


          setIsFilterDirty(
            false
          );

        } finally {

          setIsFetching(
            false
          );


          setIsFirstLoad(
            false
          );

        }

      };


    runFirstLoad();

  }, [
    GetResponseData,
    form2.ysb_dimensi_id,
    form2.ysb_semester_id,
    isFirstLoad,
  ]);


  /* =========================================================
     FILTER CHANGE
     ========================================================= */

  const handleChange = (
    e
  ) => {

    const {
      name,
      value,
    } = e.target;


    setForm2(
      (prev) => ({
        ...prev,

        [name]:
          value,
      })
    );


    if (
      !isFirstLoad
    ) {

      setIsFilterDirty(
        true
      );


      setHasSearched(
        false
      );

    }

  };


  useEffect(() => {

    setSelectedTab(
      null
    );

  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id,
  ]);


  /* =========================================================
     CARI
     ========================================================= */

  const handleCari =
    async () => {

      if (
        !isFilterComplete ||
        isFetching
      ) {
        return;
      }


      setSelectedTab(
        null
      );


      setGetData([]);


      setHasSearched(
        false
      );


      setIsFetching(
        true
      );


      try {

        await GetResponseData();


        setHasSearched(
          true
        );


        setIsFilterDirty(
          false
        );

      } finally {

        setIsFetching(
          false
        );

      }

    };


  /* =========================================================
     CELL KEY
     ========================================================= */

  const getCellKey = (
    elementId,
    rekap
  ) => {

    return `${elementId}_${
      rekap?.ysb_grade_level_id ||
      "grade"
    }_${
      rekap?.ysb_sub_element_id ||
      "sub"
    }`;

  };


  /* =========================================================
     UPDATE NILAI LOCAL
     ========================================================= */

  const updateNilaiLocal = (
    elementId,
    rekap,
    value
  ) => {

    setGetData(
      (prev) => {

        return prev.map(
          (dimensi) => ({

            ...dimensi,


            data_element: (
              dimensi?.data_element ||
              []
            ).map(
              (element) => {

                if (
                  String(
                    element?.id
                  ) !==
                  String(
                    elementId
                  )
                ) {
                  return element;
                }


                return {

                  ...element,


                  detail: (
                    element?.detail ||
                    []
                  ).map(
                    (detail) => {

                      if (
                        String(
                          detail?.ysb_grade_level_id
                        ) !==
                        String(
                          rekap?.ysb_grade_level_id
                        )
                      ) {
                        return detail;
                      }


                      return {

                        ...detail,


                        rekapan: (
                          detail?.rekapan ||
                          []
                        ).map(
                          (row) => {

                            if (
                              String(
                                row?.ysb_sub_element_id
                              ) !==
                              String(
                                rekap?.ysb_sub_element_id
                              )
                            ) {
                              return row;
                            }


                            return {

                              ...row,

                              ysb_sub_element_value:
                                value === "" ||
                                value === null ||
                                value === undefined
                                  ? null
                                  : Number(
                                      value
                                    ),

                            };

                          }
                        ),

                      };

                    }
                  ),

                };

              }
            ),

          })
        );

      }
    );

  };


  /* =========================================================
     SAVE NILAI
     ========================================================= */

  const saveNilaiDB =
    async (
      rekap,
      elementId,
      value
    ) => {

      if (
        !canInputNilai
      ) {
        return;
      }


      const recapId =
        rekap?.ysb_element_recap_head_id;


      const payload = {

        ysb_sub_element_id:
          rekap?.ysb_sub_element_id,

        ysb_sub_element_value:
          value === "" ||
          value === undefined
            ? null
            : value,

        ysb_branch_id:
          storageBranch,

        ysb_school_id:
          storageSchoolId,

        ysb_grade_level_id:
          rekap?.ysb_grade_level_id,

        ysb_dimensi_id:
          form2?.ysb_dimensi_id,

        ysb_semester_id:
          form2?.ysb_semester_id,

        ysb_element_id:
          elementId,

        user_id:
          output_id_user,

      };


      if (
        !recapId ||
        recapId ===
          "default"
      ) {

        return APILA.put(
          "/api/recaps-head/default",
          payload,
          fetchParams
        );

      }


      return APILA.put(
        `/api/recaps-head/${recapId}`,
        payload,
        fetchParams
      );

    };


  /* =========================================================
     OPEN POPUP
     ========================================================= */

  const openScorePicker = (
    event,
    elementId,
    rekap,
    isLogLocked
  ) => {

    if (
      !canInputNilai ||
      isLogLocked
    ) {
      return;
    }


    const rect =
      event.currentTarget
        .getBoundingClientRect();


    const pickerWidth =
      190;


    const pickerHeight =
      56;


    let top =
      rect.top -
      pickerHeight -
      8;


    let left =
      rect.left +
      rect.width / 2 -
      pickerWidth / 2;


    /*
      Kalau ruang atas tidak cukup,
      popup muncul di bawah input.
    */

    if (
      top < 8
    ) {

      top =
        rect.bottom + 8;

    }


    /*
      Jangan keluar layar kiri.
    */

    if (
      left < 8
    ) {

      left =
        8;

    }


    /*
      Jangan keluar layar kanan.
    */

    if (
      left +
        pickerWidth >
      window.innerWidth -
        8
    ) {

      left =
        window.innerWidth -
        pickerWidth -
        8;

    }


    originalValueRef.current =
      rekap?.ysb_sub_element_value ==
      null
        ? ""
        : String(
            rekap?.ysb_sub_element_value
          );


    setScorePicker({

      open:
        true,

      top,

      left,

      elementId,

      rekap,

    });

  };


  /* =========================================================
     CLOSE POPUP
     ========================================================= */

  useEffect(() => {

    if (
      !scorePicker.open
    ) {
      return;
    }


    const closePicker =
      () => {

        setScorePicker({
          open: false,

          top: 0,

          left: 0,

          elementId: null,

          rekap: null,
        });

      };


    const onKeyDown =
      (e) => {

        if (
          e.key ===
          "Escape"
        ) {

          closePicker();

        }

      };


    const onDocMouseDown =
      (e) => {

        const target =
          e.target;


        /*
          Klik di dalam popup:
          jangan tutup dulu.
        */

        if (
          popoverRef.current &&
          popoverRef.current.contains(
            target
          )
        ) {
          return;
        }


        /*
          Klik input lain:
          biarkan input tersebut
          membuka popup baru.
        */

        if (
          target.closest?.(
            ".ysb-score-input"
          )
        ) {
          return;
        }


        closePicker();

      };


    document.addEventListener(
      "keydown",
      onKeyDown
    );


    document.addEventListener(
      "mousedown",
      onDocMouseDown
    );


    window.addEventListener(
      "scroll",
      closePicker,
      true
    );


    window.addEventListener(
      "resize",
      closePicker
    );


    return () => {

      document.removeEventListener(
        "keydown",
        onKeyDown
      );


      document.removeEventListener(
        "mousedown",
        onDocMouseDown
      );


      window.removeEventListener(
        "scroll",
        closePicker,
        true
      );


      window.removeEventListener(
        "resize",
        closePicker
      );

    };

  }, [
    scorePicker.open,
  ]);


  /* =========================================================
     PILIH NILAI 1 - 4
     ========================================================= */

  const pickScore =
    async (
      value
    ) => {

      const rekap =
        scorePicker?.rekap;


      const elementId =
        scorePicker?.elementId;


      if (
        !rekap ||
        !elementId
      ) {
        return;
      }


      const newValue =
        Number(value);


      const oldValue =
        originalValueRef.current ??
        "";


      /*
        Kalau klik nilai yang sama,
        tidak perlu request API lagi.
      */

      if (
        String(
          newValue
        ) ===
        String(
          oldValue
        )
      ) {

        setScorePicker({
          open: false,

          top: 0,

          left: 0,

          elementId: null,

          rekap: null,
        });


        return;

      }


      const cellKey =
        getCellKey(
          elementId,
          rekap
        );


      setSavingKey(
        cellKey
      );


      /*
        Optimistic update.
      */

      updateNilaiLocal(
        elementId,
        rekap,
        newValue
      );


      try {

        await saveNilaiDB(
          rekap,
          elementId,
          newValue
        );


        ToastSuccess.fire({
          icon:
            "success",

          title:
            rekap?.ysb_element_recap_head_id ===
            "default"
              ? "Nilai berhasil disimpan"
              : "Nilai berhasil diupdate",
        });


        /*
          Refresh agar jika ID default
          berubah menjadi ID asli dari backend,
          data local ikut sinkron.
        */

        if (
          rekap?.ysb_element_recap_head_id ===
          "default"
        ) {

          await GetResponseData();

        }

      } catch (err) {

        /*
          Kalau gagal:
          balikin ke nilai sebelumnya.
        */

        updateNilaiLocal(
          elementId,
          rekap,
          oldValue === ""
            ? null
            : Number(
                oldValue
              )
        );


        ToastError.fire({
          icon:
            "error",

          title:
            err?.response?.data?.message ||
            "Gagal menyimpan nilai",
        });

      } finally {

        setSavingKey(
          null
        );


        setScorePicker({
          open: false,

          top: 0,

          left: 0,

          elementId: null,

          rekap: null,
        });

      }

    };


  /* =========================================================
     HAPUS NILAI
     ========================================================= */

  const clearScore =
    async () => {

      const rekap =
        scorePicker?.rekap;


      const elementId =
        scorePicker?.elementId;


      if (
        !rekap ||
        !elementId
      ) {
        return;
      }


      const oldValue =
        originalValueRef.current ??
        "";


      /*
        Kalau memang sudah kosong,
        cukup tutup popup.
      */

      if (
        String(
          oldValue
        ) === ""
      ) {

        setScorePicker({
          open: false,

          top: 0,

          left: 0,

          elementId: null,

          rekap: null,
        });


        return;

      }


      const cellKey =
        getCellKey(
          elementId,
          rekap
        );


      setSavingKey(
        cellKey
      );


      updateNilaiLocal(
        elementId,
        rekap,
        null
      );


      try {

        await saveNilaiDB(
          rekap,
          elementId,
          null
        );


        ToastSuccess.fire({
          icon:
            "success",

          title:
            "Nilai berhasil dihapus",
        });


        if (
          rekap?.ysb_element_recap_head_id ===
          "default"
        ) {

          await GetResponseData();

        }

      } catch (err) {

        updateNilaiLocal(
          elementId,
          rekap,
          Number(
            oldValue
          )
        );


        ToastError.fire({
          icon:
            "error",

          title:
            err?.response?.data?.message ||
            "Gagal menghapus nilai",
        });

      } finally {

        setSavingKey(
          null
        );


        setScorePicker({
          open: false,

          top: 0,

          left: 0,

          elementId: null,

          rekap: null,
        });

      }

    };


  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <>
      <style>
        {shimmerStyle}
      </style>

      <div className="body module-page assessment-page">

        {/* ===================================================
            HEADER PAGE
            =================================================== */}

        <div className="page-header-card">

          <div className="page-header-top d-flex">

            <div className="page-title-wrap">

              <span className="page-title-icon">

                <FontAwesomeIcon
                  icon={
                    faIdCard
                  }
                />

              </span>


              <h4 className="page-title-text">

                Penilaian

              </h4>

            </div>

          </div>


          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >

            <ol className="custom-breadcrumb">

              <li className="custom-breadcrumb-item">

                <Link to="/dashboards-head">

                  Beranda

                </Link>

              </li>


              <li className="custom-breadcrumb-separator">

                /

              </li>


              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >

                Penilaian

              </li>

            </ol>

          </nav>

        </div>


        {/* ===================================================
            CONTENT
            =================================================== */}

        <div className="body-content module-content mt-2">

          {/* =================================================
              FILTER MOBILE
              ================================================= */}

          {isTabletOrMobile ? (

            <div className="assessment-filter-card assessment-filter-mobile">

              <Row>

                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_semester_id"
                  value={
                    form2
                      .ysb_semester_id
                  }
                  onChange={
                    handleChange
                  }
                >

                  <option
                    value=""
                    hidden
                  >

                    {namaTA
                      ? `${namaTA} (Semester ${namaSmstr})`
                      : "Pilih Semester"}

                  </option>


                  {getDataSemesterMap.map(
                    (
                      semester,
                      index
                    ) => (

                      <option
                        key={
                          semester?.id ||
                          index
                        }
                        value={
                          semester?.id
                        }
                      >

                        {
                          semester?.name_year
                        }{" "}

                        (Semester{" "}
                        {
                          semester?.semester
                        })

                        {Number(
                          semester?.status
                        ) === 1
                          ? " • Aktif"
                          : ""}

                      </option>

                    )
                  )}

                </select>

              </Row>


              <Row>

                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_dimensi_id"
                  value={
                    form2
                      .ysb_dimensi_id
                  }
                  onChange={
                    handleChange
                  }
                    disabled={loadingDimensi || getDataDimensi.length === 0}
                >

                  <option
                    value=""
                    hidden
                  >

                    {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}

                  </option>


                  {getDataDimensi.map(
                    (
                      dimensi,
                      index
                    ) => (

                      <option
                        key={
                          dimensi?.id ||
                          index
                        }
                        value={
                          dimensi?.id
                        }
                      >

                        {
                          dimensi?.name_dimensi
                        }

                      </option>

                    )
                  )}

                </select>

              </Row>


              <Row>

                <button
                  onClick={
                    handleCari
                  }
                  disabled={
                    !isFilterComplete ||
                    isFetching
                  }
                  className="btn assessment-filter-button"
                >

                  {isFetching
                    ? "Memuat..."
                    : "Cari"}

                </button>

              </Row>

            </div>

          ) : (

            /* =================================================
               FILTER DESKTOP
               ================================================= */

            <div className="assessment-filter-card mb-3">

              {loading ? (

                <div className="assessment-filter-row d-flex">

                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width:
                        180,
                    }}
                  />


                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width:
                        220,
                    }}
                  />


                  <div
                    className="shimmer shimmer-select mr-2"
                    style={{
                      width:
                        80,
                    }}
                  />

                </div>

              ) : (

                <div className="assessment-filter-row d-flex">

                  {/* SEMESTER */}

                  <select
                    className="assessment-filter-select mr-2"
                    name="ysb_semester_id"
                    value={
                      form2
                        .ysb_semester_id
                    }
                    onChange={
                      handleChange
                    }
                  >

                    <option
                      value=""
                      hidden
                    >

                      {namaTA
                        ? `${namaTA} (Semester ${namaSmstr})`
                        : "Pilih Semester"}

                    </option>


                    {getDataSemesterMap.map(
                      (
                        semester,
                        index
                      ) => (

                        <option
                          key={
                            semester?.id ||
                            index
                          }
                          value={
                            semester?.id
                          }
                        >

                          {
                            semester?.name_year
                          }{" "}

                          (Semester{" "}
                          {
                            semester?.semester
                          })

                          {Number(
                            semester?.status
                          ) === 1
                            ? " • Aktif"
                            : ""}

                        </option>

                      )
                    )}

                  </select>


                  {/* DIMENSI */}

                  <select
                    className="assessment-filter-select mr-2"
                    name="ysb_dimensi_id"
                    value={
                      form2
                        .ysb_dimensi_id
                    }
                    onChange={
                      handleChange
                    }
                    disabled={loadingDimensi || getDataDimensi.length === 0}
                  >

                    <option
                      value=""
                      hidden
                    >

                      {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}

                    </option>


                    {getDataDimensi.map(
                      (
                        dimensi,
                        index
                      ) => (

                        <option
                          key={
                            dimensi?.id ||
                            index
                          }
                          value={
                            dimensi?.id
                          }
                        >

                          {
                            dimensi?.name_dimensi
                          }

                        </option>

                      )
                    )}

                  </select>


                  {/* CARI */}

                  <button
                    onClick={
                      handleCari
                    }
                    disabled={
                      !isFilterComplete ||
                      isFetching
                    }
                    className="btn assessment-filter-button"
                  >

                    {isFetching
                      ? "Memuat..."
                      : "Cari"}

                  </button>

                </div>

              )}

            </div>

          )}


          {/* =================================================
              SEMESTER NON AKTIF
              ================================================= */}

          {form2.ysb_semester_id &&
            !isSelectedSemesterActive && (

              <div
                className="assessment-status-banner"
                role="status"
              >

                <span className="assessment-status-dot" />


                <div>

                  <strong>

                    Semester tidak aktif.

                  </strong>{" "}

                  Data nilai tetap dapat dilihat, tetapi input nilai dinonaktifkan. Penilaian hanya dapat diinput pada semester yang berstatus aktif.

                </div>

              </div>

            )}


          {/* =================================================
              LOADER
              ================================================= */}

          {isFetching && (

            <div
              className="text-center"
              style={{
                padding:
                  "10px 0",
              }}
            >

              <PulseLoader
                color="#3f5bea"
                size={12}
              />

            </div>

          )}


          {/* =================================================
              DATA KOSONG
              ================================================= */}

          {hasSearched &&
            !isFetching &&
            getData.length ===
              0 && (

              <div className="module-table-card">

                <div className="module-empty-state-content">

                  Data penilaian belum tersedia untuk filter yang dipilih.

                </div>

              </div>

            )}


          {/* =================================================
              TAB
              ================================================= */}

          {hasSearched &&
            !isFetching &&
            getData.length >
              0 && (

              <Tabs
                activeKey={
                  selectedTab
                }
                onSelect={(key) =>
                  setSelectedTab(
                    key
                  )
                }
                className="assessment-tabs mb-3 mt-4 nav-tabs"
              >

                {(
                  getData?.[0]
                    ?.data_element ||
                  []
                ).map(
                  (
                    element,
                    eIdx
                  ) => (

                    <Tab
                      key={
                        element?.id ||
                        eIdx
                      }
                      eventKey={
                        element
                          ?.name_element
                      }
                      title={
                        element
                          ?.name_element
                      }
                      className="nav-item"
                    >

                      {/* =========================
                          DESKRIPSI
                          ========================= */}

                      <div className="assessment-element-info">

                        <h5 className="mt-2 mb-2">

                          {
                            element?.description
                          }

                        </h5>

                      </div>


                      {/* =========================
                          ROLE READ ONLY
                          ========================= */}

                      {isNilaiReadOnlyRole && (

                        <div className="head-assessment-readonly-banner">

                          <span className="head-assessment-readonly-icon">

                            i

                          </span>


                          <div>

                            <strong>

                              Mode Hanya Lihat

                            </strong>


                            <div>

                              {isPengawasAdab
                                ? "Role Pengawas Adab tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."
                                : "Role Developer tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."}

                            </div>

                          </div>

                        </div>

                      )}


                      {/* =========================
                          TABLE
                          ========================= */}

                      <Col
                        xl="12"
                        sm="12"
                        className="module-column"
                      >

                        <div className="mt-3">

                          <div className="module-table-card assessment-table-card head-assessment-table-card">

                            {/* <div className="module-table-scroll head-assessment-table-scroll"> */}
                            <div>

                              <table
                                className="module-table head-assessment-table"
                                id="basic-datatable"
                              >

                                {/* PROPORSI */}

                                <colgroup>

                                  <col
                                    style={{
                                      width:
                                        "15%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width:
                                        "45%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width:
                                        "25%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width:
                                        "15%",
                                    }}
                                  />

                                </colgroup>


                                {/* HEADER */}

                                <thead>

                                  <tr>

                                    <th>

                                      Tingkatan

                                    </th>


                                    <th>

                                      Nama Kegiatan

                                    </th>


                                    <th>

                                      Rata-Rata Penilaian Guru

                                    </th>


                                    <th>

                                      Nilai

                                    </th>

                                  </tr>

                                </thead>


                                {/* BODY */}

                                <tbody>

                                  {buildRowsWithGradeSpan(
                                    element
                                  ).map(
                                    (
                                      rekap,
                                      idx
                                    ) => {

                                      const isLogLocked =
                                        Number(
                                          rekap
                                            ?.ysb_sub_element_status
                                        ) ===
                                        0;


                                      const isScoreDisabled =
                                        isLogLocked ||
                                        !canInputNilai;


                                      const cellKey =
                                        getCellKey(
                                          element?.id,
                                          rekap
                                        );


                                      let disabledTitle =
                                        "Klik untuk pilih nilai";


                                      if (
                                        isPengawasAdab
                                      ) {

                                        disabledTitle =
                                          "Pengawas Adab hanya dapat melihat nilai";

                                      } else if (
                                        isDeveloper
                                      ) {

                                        disabledTitle =
                                          "Developer hanya dapat melihat nilai";

                                      } else if (
                                        !isSelectedSemesterActive
                                      ) {

                                        disabledTitle =
                                          "Semester tidak aktif - hanya dapat melihat nilai";

                                      } else if (
                                        isLogLocked
                                      ) {

                                        disabledTitle =
                                          "Nilai terkunci";

                                      } else if (
                                        !canUpdateNilai
                                      ) {

                                        disabledTitle =
                                          "Tidak memiliki akses untuk mengubah nilai";

                                      }


                                      return (

                                        <tr
                                          className="ysb-row-hover"
                                          key={`${
                                            rekap?.ysb_grade_level_id ||
                                            "grade"
                                          }-${
                                            rekap?.ysb_sub_element_id ||
                                            "sub"
                                          }-${idx}`}
                                        >

                                          {/* TINGKATAN */}

                                          {rekap.__showGrade && (

                                            <td
                                              rowSpan={
                                                rekap.__gradeRowSpan
                                              }
                                              className="head-assessment-grade"
                                            >

                                              {rekap?.name_tingkatan ||
                                                "-"}

                                            </td>

                                          )}


                                          {/* KEGIATAN */}

                                          <td className="head-assessment-activity">

                                            {rekap?.ysb_sub_element_name ||
                                              rekap?.description ||
                                              "-"}

                                          </td>


                                          {/* RATA-RATA GURU */}

                                          <td
                                            className={`head-assessment-average ${
                                              isLogLocked
                                                ? "is-locked"
                                                : ""
                                            }`}
                                          >

                                            {rekap?.ysb_sub_element_value_teacher_average ??
                                              "-"}

                                          </td>


                                          {/* NILAI */}

                                          <td className="head-assessment-score">

                                            <div className="head-assessment-score-wrap">

                                              {savingKey ===
                                              cellKey ? (

                                                <div
                                                  style={{
                                                    height:
                                                      "36px",

                                                    display:
                                                      "flex",

                                                    alignItems:
                                                      "center",

                                                    justifyContent:
                                                      "center",
                                                  }}
                                                >

                                                  <ClipLoader
                                                    size={
                                                      14
                                                    }
                                                    color="#3f5bea"
                                                  />

                                                </div>

                                              ) : (

                                                <input
                                                  type="text"

                                                  value={
                                                    rekap?.ysb_sub_element_value ??
                                                    ""
                                                  }

                                                  readOnly

                                                  disabled={
                                                    isScoreDisabled
                                                  }

                                                  title={
                                                    disabledTitle
                                                  }

                                                  className={`ysb-score-input form-control text-center ${
                                                    isScoreDisabled
                                                      ? "ysb-input-disabled"
                                                      : ""
                                                  }`}

                                                  onClick={(
                                                    e
                                                  ) => {

                                                    openScorePicker(
                                                      e,
                                                      element?.id,
                                                      rekap,
                                                      isLogLocked
                                                    );

                                                  }}
                                                />

                                              )}


                                              {/* LOCK ICON */}

                                              {isLogLocked &&
                                                savingKey !==
                                                  cellKey && (

                                                  <div className="head-assessment-lock-overlay">

                                                    <FontAwesomeIcon
                                                      icon={
                                                        faLock
                                                      }
                                                    />

                                                  </div>

                                                )}

                                            </div>

                                          </td>

                                        </tr>

                                      );

                                    }
                                  )}

                                </tbody>

                              </table>

                            </div>

                          </div>

                        </div>

                      </Col>

                    </Tab>

                  )
                )}

              </Tabs>

            )}

        </div>

      </div>


      {/* =====================================================
          POPUP PILIH NILAI
          ===================================================== */}

      {scorePicker.open && (

        <div
          ref={
            popoverRef
          }
          className="ysb-score-popover"
          style={{
            top:
              scorePicker.top,

            left:
              scorePicker.left,
          }}
          onMouseDown={(
            e
          ) =>
            e.stopPropagation()
          }
        >

          <div className="ysb-score-popover-grid-inline">

            {[1, 2, 3, 4].map(
              (nilai) => (

                <button
                  key={
                    nilai
                  }
                  type="button"
                  className="ysb-score-btn"
                  onMouseDown={(
                    e
                  ) => {

                    e.preventDefault();


                    pickScore(
                      nilai
                    );

                  }}
                >

                  {
                    nilai
                  }

                </button>

              )
            )}


            <button
              type="button"
              className="ysb-score-btn ysb-score-btn-trash"
              title="Hapus nilai"
              onMouseDown={(
                e
              ) => {

                e.preventDefault();


                clearScore();

              }}
            >

              <FiTrash2
                size={
                  16
                }
              />

            </button>

          </div>

        </div>

      )}

    </>
  );
}